import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CheckEnclosedSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 16 16",
  color = "#ccc",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="check-enclosed">
        <path
          id="Vector"
          d="M8.28877 14.7135C11.9361 14.7135 14.9583 11.6958 14.9583 8.04688C14.9583 4.39794 11.9303 1.38021 8.28296 1.38021C4.6388 1.38021 1.625 4.39794 1.625 8.04688C1.625 11.6958 4.64461 14.7135 8.28877 14.7135ZM8.28877 13.7317C5.14373 13.7317 2.61542 11.1991 2.61542 8.04688C2.61542 4.89466 5.13792 2.36205 8.28296 2.36205C11.4338 2.36205 13.9711 4.89466 13.9711 8.04688C13.9711 11.1991 11.4396 13.7317 8.28877 13.7317ZM7.57311 11.1777C7.7623 11.1777 7.92047 11.086 8.0406 10.9103L11.1484 6.03186C11.2148 5.9195 11.2839 5.78771 11.2839 5.66113C11.2839 5.40535 11.0573 5.23408 10.8106 5.23408C10.6615 5.23408 10.5155 5.32262 10.4038 5.49507L7.54729 10.0516L6.136 8.26966C5.99525 8.08559 5.86612 8.0371 5.70594 8.0371C5.45609 8.0371 5.25587 8.23801 5.25587 8.49899C5.25587 8.62499 5.31013 8.75098 5.39021 8.86275L7.07659 10.9103C7.22576 11.1002 7.3755 11.1777 7.57311 11.1777Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export { CheckEnclosedSvg };
